import {Link, useNavigate} from 'react-router';
import Text from '@atoms/Text';
import {theme} from '@styles/theme';
import {ReactComponent as Logo} from '@assets/logo.svg';
import Input from '@atoms/Input';
import {useState} from 'react';
import Button from '@atoms/Button';
import {ERoutes} from '@constants/routes';
import IconWithBackground from '@atoms/IconWithBackground';
import {Email} from '@carbon/icons-react';
import {
  AuthPageWrapper,
  AuthPageContentWrapper,
  AuthPageFieldsWrapper,
  AuthPageMainContentWrapper,
  AuthPageBottomContentWrapper,
  Form,
} from '@pages/AuthPage.styles';
import {recoveryPassword} from '@store/slices/users';
import {Formik} from 'formik';
import {useDispatch} from 'react-redux';
import {AppDispatch} from '@store';
import {toast} from "react-toastify";
import Toast from "@atoms/Toast";

export const AuthRecoveryPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = (values: {email: string}) => {
    dispatch(recoveryPassword(values))
      .unwrap()
      .then(() => {
        setEmailSent(true);
      })
      .catch((err: any) => {
        toast.error(
          <Toast
            title="Ошибка"
            text={err?.message || 'Не удалось сбросить пароль'}
            type="error"
          />,
        );
      });
  };

  return (
    <AuthPageWrapper>
      <AuthPageContentWrapper>
        <AuthPageMainContentWrapper>
          {!emailSent && (
            <>
              <Logo />
              <Text text="Восстановить пароль" type="titleR" />
              <Text
                text="Введите ваш логин/email и мы вышлем ссылку на восстановление пароля."
                align="center"
              />
              <Formik
                enableReinitialize
                initialValues={{email: ''}}
                onSubmit={handleSubmit}>
                {({handleSubmit, values, setFieldValue, touched, errors}) => {
                  return (
                    <Form onSubmit={handleSubmit}>
                      <AuthPageFieldsWrapper>
                        <Input
                          id="login"
                          label="Логин (email)"
                          value={values.email}
                          onChange={e => {
                            setFieldValue('email', e.currentTarget.value);
                          }}
                          error={touched.email && errors.email ? errors.email : ''}
                          withoutErrorText
                        />
                      </AuthPageFieldsWrapper>
                      <Button
                        title="Сбросить пароль"
                        variant="filled"
                        type="submit"
                        size="big"
                        fullWidth
                        disabled={!values.email}
                      />
                    </Form>
                  );
                }}
              </Formik>
            </>
          )}
          {emailSent && (
            <>
              <IconWithBackground
                icon={<Email size={28} fill={theme.colors.accent00} />}
                successMark
              />
              <Text text="Готово" type="titleR" />
              <Text
                text="Мы выслали ссылку на восстановление пароля на указанный email. Проверьте входящие сообщения."
                align="center"
              />
              <Button
                title="Авторизация"
                variant="filled"
                size="big"
                fullWidth
                onClick={() => navigate(ERoutes.AUTHORIZATION)}
              />
            </>
          )}
        </AuthPageMainContentWrapper>
        {!emailSent && (
          <AuthPageBottomContentWrapper>
            <Link to={ERoutes.AUTHORIZATION}>
              <Text text="Назад к форме авторизации" color={theme.colors.accent00} />
            </Link>
          </AuthPageBottomContentWrapper>
        )}
      </AuthPageContentWrapper>
    </AuthPageWrapper>
  );
};

export default AuthRecoveryPage;
